<script setup>
import { computed } from 'vue';
import { useNow } from '@vueuse/core';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  waitingSince: { type: Number, default: 0 },
});

const { t } = useI18n();
const now = useNow({ interval: 60000 });

const waitingMinutes = computed(() => {
  if (!props.waitingSince) return 0;

  return Math.max(
    0,
    Math.floor((now.value.getTime() - props.waitingSince * 1000) / 60000)
  );
});

const label = computed(() => {
  if (waitingMinutes.value >= 60) {
    return t('CHAT_LIST.HUMAN_REPLY_QUEUE.WAITING_HOURS', {
      hours: Math.floor(waitingMinutes.value / 60),
    });
  }

  return t('CHAT_LIST.HUMAN_REPLY_QUEUE.WAITING_MINUTES', {
    minutes: waitingMinutes.value,
  });
});

const severityClass = computed(() => {
  if (waitingMinutes.value >= 15) {
    return 'bg-n-ruby-3 text-n-ruby-11';
  }
  if (waitingMinutes.value >= 5) {
    return 'bg-n-amber-3 text-n-amber-11';
  }
  return 'bg-n-slate-3 text-n-slate-11';
});
</script>

<template>
  <span
    class="inline-flex flex-shrink-0 items-center h-5 px-1.5 text-xxs font-medium leading-none whitespace-nowrap rounded"
    :class="severityClass"
  >
    {{ label }}
  </span>
</template>
